import React from 'react';
import SimpleInfoPanel from '../SimpleInfoPanel';
import {formatCurrencyValue} from '../../util/PaymentUtils';
import BookSpaceInfoPanelContent from './profile/BookSpaceInfoPanelContent';
import {styled} from "@mui/material/styles";

const PayoutSummarySimpleInfoPanel = styled(SimpleInfoPanel)(({theme}) => ({
  padding: '1.43rem',
  backgroundColor: theme.palette.grey[100],
  borderRadius: '0.57rem',
}));

interface PayoutSummaryInfoPanelProps {
  // '' until an admin enters an amount in the booking form, then a number (same as ChargeOveragesForm's props).
  customerAmount: string | number;
  partnerAmount: string | number;
  securSpaceAmount?: number;
}

const PayoutSummaryInfoPanelContent = ({ customerAmount, partnerAmount, securSpaceAmount }: PayoutSummaryInfoPanelProps) => {
  const panelData = [
    {
      label: 'Customer Amount',
      value: formatCurrencyValue(customerAmount || 0, true),
    },
    {
      label: 'Partner Amount',
      value: formatCurrencyValue(partnerAmount || 0, true),
    },
    {
      label: 'SecurSpace Amount',
      value: formatCurrencyValue(securSpaceAmount || 0, true),
    }
  ];
  return (
    <BookSpaceInfoPanelContent data={panelData} />
  );
};

const PayoutSummaryInfoPanel = (props: PayoutSummaryInfoPanelProps) => {
  const { customerAmount, partnerAmount, securSpaceAmount } = props;

  return (
    <PayoutSummarySimpleInfoPanel
      title='Payout Summary'
      content={<PayoutSummaryInfoPanelContent customerAmount={customerAmount} partnerAmount={partnerAmount} securSpaceAmount={securSpaceAmount} /> }
    />
  );
};

export default PayoutSummaryInfoPanel;
